import React from "react";

const Avatar = () => {
  return (
    <div className="flex justify-center pt-10 ">
      <img
        src="./Perfil.jpg"
        alt=""
        className="w-28 rounded-full h-28 z-10"
      />
    </div>
  );
};

export default Avatar;
